import { colors } from "@dotnet/telematics-design-system";

import { ACTIVITY_STATUS } from "shared/types/enums";

import { EMPTY, LOADING } from "../../constants";

const useColors = () => {
    const {
        gray100,
        gray200,
        gray300,
        gray400,
        gray700,
        gray900,
        green700,
        textDisabled,
        textPlaceholder,
        white
    } = colors;

    const statusColors = {
        [ACTIVITY_STATUS.Online]: {
            bg: {
                rest: green700,
                hover: "#C5DFCF"
            },
            border: {
                rest: green700,
                hover: "#C5DFCF"
            }
        },
        [ACTIVITY_STATUS.Offline]: {
            bg: {
                rest: gray200,
                hover: "#F8F9FB"
            },
            border: {
                rest: gray400,
                hover: "#E0E8ED"
            }
        },
        [ACTIVITY_STATUS.Inactive]: {
            bg: {
                rest: white,
                hover: white
            },
            border: {
                rest: gray400,
                hover: "#E0E8ED"
            }
        },
        [EMPTY]: {
            bg: {
                rest: gray300,
                hover: gray300
            },
            border: {
                rest: gray300,
                hover: gray300
            }
        },
        [LOADING]: {
            bg: {
                rest: gray100,
                hover: gray100
            },
            border: {
                rest: gray100,
                hover: gray100
            }
        }
    };

    return {
        statusColors,
        gray700,
        gray900,
        textDisabled,
        textPlaceholder
    };
};

export { useColors };
